'use client'

import { useState } from 'react'
import Link from 'next/link'
import { ArrowRight, Check, Copy } from 'lucide-react'
import { track } from '@/lib/analytics/track'

interface MobileActionBarProps {
  slug: string
  promptText: string
}

export function MobileActionBar({ slug, promptText }: MobileActionBarProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    await navigator.clipboard.writeText(promptText)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="bg-background/95 fixed inset-x-0 bottom-0 z-50 border-t backdrop-blur-sm lg:hidden">
      <div className="mx-auto flex max-w-5xl items-center gap-3 px-4 py-3">
        <button
          onClick={handleCopy}
          className="flex h-11 flex-1 items-center justify-center gap-2 rounded-lg border text-sm font-medium transition-colors hover:bg-muted"
        >
          {copied ? (
            <Check className="h-4 w-4 text-green-600" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
          {copied ? 'Copied!' : 'Copy Full Skill'}
        </button>
        <Link
          href="/sign-up"
          onClick={() => track('skill_detail_cta_click', { slug, cta_location: 'sticky_bar' })}
          className="bg-foreground text-background flex h-11 flex-1 items-center justify-center gap-2 rounded-lg text-sm font-medium transition-opacity hover:opacity-90"
        >
          Try in Soku AI
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  )
}
